import {
  MAP_STYLES,
  MAP_MARKER_ICON,
  MAP_MARKER_ACTIVE_ICON,
} from '../constants/maps';
import { loadAPI } from '../api/google-maps';

/**
 * Prevent Roboto font being loaded by Google maps
 */
function removeFont() {
  const head = document.getElementsByTagName('head')[0];

  // Save the original method
  const insertBefore = head.insertBefore;

  // Replace it!
  head.insertBefore = function (newElement, referenceElement) {
    if (
      newElement.href &&
      newElement.href.indexOf(
        'https://fonts.googleapis.com/css?family=Roboto',
      ) === 0
    ) {
      return;
    }

    insertBefore.call(head, newElement, referenceElement);
  };
}

removeFont();

document.addEventListener('alpine:init', () => {
  Alpine.data('map', (input) => {
    return {
      loaded: false,
      init() {
        this.createMapObserver(this.$el, 0, this.loadMap.bind(this), () => null)
      },
      /**
       * Defer loading map until element is almost within viewport
       */
      createMapObserver(element, threshold, callbackIn, callbackOut) {
        const config = {
          rootMargin: '0px 0px 200px 0px',
          threshold,
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadAPI().then(callbackIn);
            } else {
              callbackOut();
            }
          });
        }, config);

        observer.observe(element);
      },

      loadMap() {
        // eslint-disable-next-line
        if (!window.hasOwnProperty('google')) {
          return;
        }

        const { locations, mapCenter, zoom } = input;

        const map = new google.maps.Map(this.$el, {
          center: mapCenter,
          zoom: zoom || 6,
          styles: MAP_STYLES,
        });

        const infoWindow = new google.maps.InfoWindow({
          content: '',
        });

        locations.forEach((location) => {
          const marker = new google.maps.Marker({
            position: location.center,
            map,
            animation: google.maps.Animation.DROP,
            title: location.title,
            icon: MAP_MARKER_ICON,
          });

          google.maps.event.addListener(marker, 'click', () => {
            infoWindow.setContent(this.addContent(location.title, location.description));
            infoWindow.open(map, marker);
          });

          google.maps.event.addListener(marker, 'mouseover', () => {
            marker.setIcon(MAP_MARKER_ACTIVE_ICON);
          });

          google.maps.event.addListener(marker, 'mouseout', () => {
            marker.setIcon(MAP_MARKER_ICON);
          });
        });
      },

      addContent(title = '', content = '') {
        return [
          '<div class="info-window">',
          `<h4 class="info-window__title">${title}</h2>`,
          '<div class="info-window__body">',
          `<p>${content}</p>`,
          '</div>',
          '</div>',
        ].join('');
      }
    }
  });
});
